module.exports = __webpack_public_path__ + "7bfd00b6e64f03dbe5de38ee32f9eef0.png";